import { useWalmartDisabledRedirect } from 'pages/loyalty/loyalty-partners/walmart/use-walmart-disabled-redirect';
import { WalmartLocation } from 'pages/loyalty/loyalty-partners/walmart/walmart-location';

export default function WalmartLocationPage() {
  const disabledRedirect = useWalmartDisabledRedirect();
  if (disabledRedirect) {
    return disabledRedirect;
  }
  return <WalmartLocation />;
}
